import BookingProvider from './BookingProvider';

class Booking {
  constructor() {
    this.provider = new BookingProvider();
  }
}

export default new Booking();
